//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.GenerateInspectionReportPdfQuery_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.GenerateInspectionReportPdfQuery_VariablesAdapter
import com.wintermar.inspection.graphql.selections.GenerateInspectionReportPdfQuerySelections
import com.wintermar.inspection.graphql.type.GenerateInspectionReportPdfQueryInput
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public data class GenerateInspectionReportPdfQuery(
  public val `param`: GenerateInspectionReportPdfQueryInput,
) : Query<GenerateInspectionReportPdfQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    GenerateInspectionReportPdfQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = GenerateInspectionReportPdfQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = GenerateInspectionReportPdfQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(GenerateInspectionReportPdfQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val generateInspectionReportPdf: GenerateInspectionReportPdf,
  ) : Query.Data

  public data class GenerateInspectionReportPdf(
    public val inspectionId: Any,
    public val fileName: String,
    public val url: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "3b352759fd37db5f6b5278e4ad25cb4c6158fe604e237eb7f1ff24ea6d22151d"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query generateInspectionReportPdf($param: GenerateInspectionReportPdfQueryInput!) {
     *   generateInspectionReportPdf(query: $param) {
     *     inspectionId
     *     fileName
     *     url
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query generateInspectionReportPdf(${'$'}param: GenerateInspectionReportPdfQueryInput!) { generateInspectionReportPdf(query: ${'$'}param) { inspectionId fileName url } }"

    public const val OPERATION_NAME: String = "generateInspectionReportPdf"
  }
}
